// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ACTION_TO_SET_FAVORITE_TOPIC = "pridanie kateg\u00f3rie do ob\u013e\u00faben\u00fdch";
export const ACTION_TO_SUBSCRIBE_TOPIC = "odoberanie kateg\u00f3rie";
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_TOPIC = "Naozaj chce\u0161 kateg\u00f3riu zmaza\u0165?";
export const EXPLAIN_TOPIC_DELETION = "Zadaj bli\u017e\u0161ie od\u00f4vodnenie: ";
export const FORUM_TOPIC_ALREADY_SUBSCRIBED_TOAST_name = "Odober\u00e1\u0161 %(name)s.";
export const FORUM_TOPIC_SUBSCRIBED_TOAST_name = "Za\u010dala si odobera\u0165 %(name)s.";
export const FORUM_TOPIC_topic_IS_ADDED_TO_FAVORITES = "Pridala si kateg\u00f3riu %(topic)s k ob\u013e\u00faben\u00fdm.";
export const FORUM_TOPIC_topic_IS_REMOVED_FROM_FAVORITES = "Odstr\u00e1nila si kateg\u00f3riu %(topic)s z ob\u013e\u00faben\u00fdch.";
export const FORUM_TOPIC_UNSUBSCRIBED_TOAST_name = "U\u017e neodober\u00e1\u0161 %(name)s.";
